"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInteger = void 0;
const is_integer_1 = require("../is-integer/is-integer");
/**
 * @summary Parses a string into an integral number.
 *
 * Parses a string to a number. Float values are rejected. Whitespace at the beginning and end
 * are ignored.
 *
 * If the string does not contain an integral number, returns `NaN`.
 *
 * @param {string | undefined} text
 * @returns {number}
 *
 * @example
 * const int = parseInteger('5');
 */
function parseInteger(text) {
    if (!text || !(0, is_integer_1.isInteger)(text)) {
        return NaN;
    }
    return +text;
}
exports.parseInteger = parseInteger;
